import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "engine/modules/authRequest"
import env from "src/env"
import get from "lodash/get"
import { READ_EVENT_RESOURCES_LIST } from "../actions/types"
import {
  readEventResourcesListSuccess,
  readEventResourcesListError,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

// read list saga
function* requestRead(action) {
  const {
    config: { uuid },
  } = action
  try {
    const response = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/${uuid}/resources`,
      method: `get`,
    })
    const responseData = get(response, `data`)
    yield put(readEventResourcesListSuccess(action, responseData))
  } catch (error) {
    yield put(readEventResourcesListError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(READ_EVENT_RESOURCES_LIST, requestRead)
}
